import {SET, DELETED, ADDED} from './actionTypes';
import update from "immutability-helper";

const initialState = [];

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case ADDED:
      return {
        ...state,
        [action.surveyShare.id]: action.surveyShare
      };

    case SET:
      return action.surveyShares;

    case DELETED:
      return update(state, {$unset: [action.surveyShare.id]});

    default:
      return state;
  }
};